module.exports = __webpack_public_path__ + "img/img_skymain_100.608af68d.svg";